import React from 'react';
import Header from '../components/Header';

const LegalPages = ({ type }) => {
  return (
    <div className="min-h-screen bg-charcoal text-cream">
      <Header />
      <div className="max-w-4xl mx-auto px-4 py-32">
        {type === 'mentions' ? (
          <>
            <h1 className="text-3xl font-bold text-gold mb-8">Mentions légales</h1>
            <div className="space-y-6 text-cream/80 leading-relaxed">
              <div>
                <h2 className="text-xl font-bold text-cream mb-2">Éditeur du site</h2>
                <p>Nom : COURDOUAN Robert</p>
                <p>Forme juridique : Entrepreneur individuel (Micro-entreprise)</p>
                <p>SIREN : 932 491 400</p>
                <p>SIRET : 932 491 400 00010</p>
                <p>Numéro TVA : FR32932491400</p>
                <p>RCS : 932 491 400 R.C.S. Toulon</p>
                <p>Code NAF/APE : 56.21Z (Services des traiteurs)</p>
                <p>Adresse : Solliès-Pont, Var (83)</p>
                <p>Email : dusourirealafourchette@gmail.com</p>
                <p>Site web : www.dusourirealafourchette.com</p>
              </div>
              <div>
                <h2 className="text-xl font-bold text-cream mb-2">Création du site</h2>
                <p>Site créé par LEPETIT Armael</p>
                <p>Email : armaellepetito@gmail.com</p>
              </div>
              <div>
                <h2 className="text-xl font-bold text-cream mb-2">Hébergeur</h2>
                <p>Vercel Inc.</p>
                <p>440 N Barranca Ave #4133</p>
                <p>Covina, CA 91723 — États-Unis</p>
                <p>https://vercel.com</p>
              </div>
              <div>
                <h2 className="text-xl font-bold text-cream mb-2">Propriété intellectuelle</h2>
                <p>L'ensemble du contenu de ce site (textes, images, logo) est la propriété exclusive de COURDOUAN Robert. Toute reproduction sans autorisation est interdite.</p>
              </div>
            </div>
          </>
        ) : (
          <>
            <h1 className="text-3xl font-bold text-gold mb-8">Politique de confidentialité</h1>
            <div className="space-y-6 text-cream/80 leading-relaxed">
              <div>
                <h2 className="text-xl font-bold text-cream mb-2">Responsable du traitement</h2>
                <p>COURDOUAN Robert — Solliès-Pont, Var (83)</p>
                <p>Email : dusourirealafourchette@gmail.com</p>
              </div>
              <div>
                <h2 className="text-xl font-bold text-cream mb-2">Données collectées</h2>
                <p>Dans le cadre du formulaire de réservation, nous collectons :</p>
                <ul className="list-disc ml-6 mt-2 space-y-1">
                  <li>Nom et prénom</li>
                  <li>Adresse email</li>
                  <li>Numéro de téléphone</li>
                  <li>Date et type d'événement</li>
                </ul>
              </div>
              <div>
                <h2 className="text-xl font-bold text-cream mb-2">Utilisation des données</h2>
                <p>Ces données sont utilisées uniquement pour traiter votre demande de devis ou de réservation. Elles ne sont jamais vendues ni transmises à des tiers.</p>
              </div>
              <div>
                <h2 className="text-xl font-bold text-cream mb-2">Durée de conservation</h2>
                <p>Vos données sont conservées 3 ans à compter de votre dernière demande.</p>
              </div>
              <div>
                <h2 className="text-xl font-bold text-cream mb-2">Vos droits</h2>
                <p>Conformément au RGPD, vous disposez d'un droit d'accès, de rectification et de suppression de vos données. Pour exercer ces droits : dusourirealafourchette@gmail.com</p>
              </div>
              <div>
                <h2 className="text-xl font-bold text-cream mb-2">Cookies</h2>
                <p>Ce site n'utilise pas de cookies de tracking ou publicitaires.</p>
              </div>
              <div>
                <h2 className="text-xl font-bold text-cream mb-2">Hébergeur</h2>
                <p>Vercel Inc. — https://vercel.com</p>
              </div>
            </div>
          </>
        )}
      </div>
    </div>
  );
};

export default LegalPages;
